import { MousePointer } from 'lucide-react';

export const DELAY_UNITS = [
    { value: 'seconds', label: 'Segundos', factor: 1 },
    { value: 'minutes', label: 'Minutos', factor: 60 },
    { value: 'hours', label: 'Horas', factor: 3600 },
    { value: 'days', label: 'Dias', factor: 86400 },
];

export const TYPING_UNITS = [
    { value: 'seconds', label: 'Segundos', factor: 1 },
    { value: 'minutes', label: 'Minutos', factor: 60 },
];

export const SMART_DELAY_UNITS = [
    { value: 'seconds', label: 'Segundos', factor: 1 },
    { value: 'minutes', label: 'Minutos', factor: 60 },
];

export const TRIGGER_TIMEOUT_UNITS = [
    { value: 'seconds', label: 'Seg', factor: 1 },
    { value: 'minutes', label: 'Min', factor: 60 },
    { value: 'hours', label: 'Hrs', factor: 3600 },
];

export const PIX_CODE_FORMATS = [
    { value: 'blockquote', label: 'Citação (padrão)' },
    { value: 'text', label: 'Texto Simples' },
    { value: 'code_block', label: 'Bloco de Código' },
];

// Hex equivalentes dos bg-* do Tailwind usados nos blocos
export const NODE_COLORS = {
    text: '#3b82f6', // bg-blue-500
    image: '#22c55e', // bg-green-500
    video: '#ef4444', // bg-red-500
    audio: '#a855f7', // bg-purple-500
    input: '#0ea5e9', // bg-sky-500
    typing: '#eab308', // bg-yellow-500
    delay: '#facc15', // bg-yellow-400
    smart_delay: '#eab308', // bg-yellow-500
    randomizer: '#38bdf8', // bg-sky-400
    trigger: '#f43f5e', // bg-rose-500
    payment: '#10b981', // bg-emerald-500
    card_payment: '#6366f1', // bg-indigo-500
    spei_payment: '#14b8a6', // bg-teal-500
    entregavel: '#3b82f6', // bg-blue-500
    location: '#06b6d4', // bg-cyan-500
    buttons: '#8b5cf6', // bg-violet-500
    composed: '#8b5cf6', // bg-violet-500
    goto: '#64748b', // bg-slate-500
    order_bump: '#f59e0b', // bg-amber-400
};

export const BLOCK_GROUPS = [
    {
        title: 'Comunicação',
        items: [
            {
                type: 'composed',
                label: 'Mensagem Composta',
                icon: 'fas fa-layer-group',
                color: 'bg-violet-500',
            },
            {
                type: 'text',
                label: 'Texto',
                icon: 'fas fa-font',
                color: 'bg-blue-500',
            },
            {
                type: 'image',
                label: 'Imagem',
                icon: 'fas fa-image',
                color: 'bg-green-500',
            },
            {
                type: 'video',
                label: 'Vídeo',
                icon: 'fas fa-video',
                color: 'bg-red-500',
            },
            {
                type: 'audio',
                label: 'Áudio',
                icon: 'fas fa-microphone',
                color: 'bg-purple-500',
            },
            {
                type: 'input',
                label: 'Input do usuário',
                icon: 'fas fa-keyboard',
                color: 'bg-sky-500',
            },
            {
                type: 'typing',
                label: 'Digitando...',
                icon: 'fas fa-keyboard',
                color: 'bg-yellow-500',
            },
            {
                type: 'location',
                label: 'Localização',
                icon: 'fas fa-map-marker-alt',
                color: 'bg-cyan-500',
            },
            {
                type: 'buttons',
                label: 'Botões',
                icon: <MousePointer size={12} />,
                color: 'bg-violet-500',
            },
        ],
    },
    {
        title: 'Lógica & Fluxo',
        items: [
            {
                type: 'delay',
                label: 'Atraso',
                icon: 'fas fa-clock',
                color: 'bg-yellow-400',
            },
            {
                type: 'smart_delay',
                label: 'Atraso Humanizado',
                icon: 'fas fa-hourglass-half',
                color: 'bg-yellow-500',
            },
            // {
            //     type: 'condition',
            //     label: 'Condição',
            //     icon: 'fas fa-code-branch',
            //     color: 'bg-pink-500',
            // },
            {
                type: 'randomizer',
                label: 'Randomizador',
                icon: 'fas fa-random',
                color: 'bg-sky-400',
            },
            {
                type: 'trigger',
                label: 'Gatilho',
                icon: 'fas fa-bolt',
                color: 'bg-rose-500',
            },
            {
                type: 'goto',
                label: 'Ir Para',
                icon: 'fas fa-arrow-right',
                color: 'bg-slate-500',
            },
        ],
    },
    {
        title: 'Pagamentos',
        items: [
            {
                type: 'payment',
                label: 'Gerar PIX',
                icon: 'fas fa-credit-card',
                color: 'bg-emerald-500',
            },
            {
                type: 'card_payment',
                label: 'Gerar pagamento cartão',
                icon: 'fas fa-money-check-dollar',
                color: 'bg-indigo-500',
            },
            {
                type: 'spei_payment',
                label: 'Gerar pagamento SPEI',
                icon: 'fas fa-building-columns',
                color: 'bg-teal-500',
            },
            {
                type: 'order_bump',
                label: 'Order Bump',
                icon: 'fas fa-gift',
                color: 'bg-amber-400',
            },
        ],
    },
    {
        title: 'Entregáveis',
        items: [
            {
                type: 'entregavel',
                label: 'Entregável',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
                        <path d="M12 22V12" />
                        <polyline points="3.29 7 12 12 20.71 7" />
                        <path d="m7.5 4.27 9 5.15" />
                    </svg>
                ),
                color: 'bg-blue-500',
            },
        ],
    },
];
